<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="../img/logo.svg" class="img" />
          <div class="title title-28">
            rust<span class="gray">legacys</span>
          </div>
        </router-link>
      </div>
      <div class="center">
        <ul class="nav">
          <li class="nav__item">
            <router-link to="/" class="desc"> HOME </router-link>
          </li>
          <li class="nav__item">
            <div class="desc" @click="scrollToSection('#faq')">FAQ</div>
          </li>
          <li class="nav__item">
            <router-link to="/products" class="desc"> SHOP </router-link>
          </li>
          <li class="nav__item">
            <div class="desc" @click="scrollToSection('#how')">
              HOW IT WORKS
            </div>
          </li>
        </ul>
      </div>
      <div class="right">
        <div
          class="select-container"
          v-if="curr && $parent.currencyOptions.length > 1"
        >
          <select
            class="select currency-select"
            v-model="curr"
            @change="selectCurr()"
          >
            <option :value="item" v-for="item in currOptions" :key="item">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="balance" v-if="$parent.isAuth">
          <button class="button" @click="$parent.openTopUpModal">
            <img src="../img/corners/top-left-corner.svg" class="top-left" />
            <img src="../img/corners/top-right-corner.svg" class="top-right" />
            <img
              src="../img/corners/bottom-left-corner.svg"
              class="bottom-left"
            />
            <img
              src="../img/corners/bottom-right-corner.svg"
              class="bottom-right"
            />
            <div class="balance-text">
              <img src="../img/wallet.svg" class="img" />
              <span class="desc amount"
                >{{ Math.floor($parent.profileData.balance * 100) / 100 }}
              </span>

              <img src="../img/coin.svg" class="coin" />
            </div>
          </button>
        </div>
        <router-link to="/cart" class="cart" v-if="$parent.isAuth">
          <img src="../img/cart.svg" class="img" />
          <div v-if="$parent.cartContents.length" class="desc indicator">
            {{ $parent.cartContents.length }}
          </div>
        </router-link>
        <router-link to="/profile" class="desc name-desc" v-if="$parent.isAuth">
          <img src="../img/gg_profile.svg" class="gg_profile" />
        </router-link>
        <div
          class="button black button-login"
          v-if="!$parent.isAuth"
          @click="$parent.openAgeModal()"
        >
          <img src="../img/corners/top-left-corner.svg" class="top-left" />
          <img src="../img/corners/top-right-corner.svg" class="top-right" />
          <img
            src="../img/corners/bottom-left-corner.svg"
            class="bottom-left"
          />
          <img
            src="../img/corners/bottom-right-corner.svg"
            class="bottom-right"
          />
          <img src="../img/steam.svg" class="img" />
          LOGIN WITH STEAM
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: ["currency", "currencyCode", "currencyValue"],
  data: function () {
    return {
      curr: "",
    };
  },
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ code }) => code);
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue;
    },
  },
  mounted() {
    this.curr = this.currencyCode;
  },
  methods: {
    selectCurr() {
      this.changeCurrency(this.curr);
      localStorage.setItem("currency", this.curr);
    },
    changeCurrency(item) {
      this.$emit("changeCurrency", item);
    },
    openSignInModal() {
      this.$emit("openSignInModal");
    },
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    decrease() {
      if (this.amount > 0) {
        this.amount = this.amount - 1;
      } else {
        this.amount = 0;
      }
    },
    increase() {
      this.amount = this.amount + 1;
    },
    toCheckout() {
      if (this.amount > 0) {
        this.topUpIsVisible = false;
        this.$emit("setAmount", this.amount);
        this.$router.push({ path: "cart", query: { amount: this.amount } });
      }
    },
  },
};
</script>
